export const TEMPLATES_PER_PAGE = 30;
export const MESSAGE_TEMPLATES_FILTERS_MAPPING = {
    title: 'title',
};
export const MESSAGE_TEMPLATES_SORTING_MAPPING = {
    title: 'order[title]',
};
